module.exports = __webpack_public_path__ + "img/illustrations-empty_data.5a2d213f.svg";